<template>
  <section>
    <section v-if="detailLoading" class="loader-container">
      <Loader text="Cargando pedido" />
    </section>

    <v-card
      v-else
      flat
      :class="{
        urgent: request?.is_urgency,
      }"
    >
      <div
        v-if="!!fab"
        @click="fab = false"
        style="position: fixed; height: 100vh; width: 100vw"
        :class="{ overlay: fab }"
      ></div>
      <v-container class="bodypad">
        <v-row v-if="request">
          <div class="left-col" v-bind:class="{ hidden: fab }">
            <v-row>
              <!-- Urgency -->
              <v-col cols="12" style="color: #ff5252" v-if="request.is_urgency">
                <b>PEDIDO URGENTE</b>
              </v-col>

              <!-- Request Status -->
              <v-col cols="12">
                <v-chip
                  label
                  color="rapiblue"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  {{ request.status_request?.description }}
                </v-chip>
              </v-col>

              <!-- Scheme Icon and Service name -->
              <v-col cols="12">
                <h6
                  class="d-flex align-center p-0 m-0 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Tipo de servicio
                </h6>
                <p style="text-transform: capitalize; display: flex; align-items: center;">
                  <template v-if="$store.state.app_display_scheme">
                    <SchemeIcon :scheme="request.scheme" style="min-width: 25px; min-height: 24px;"/>
                  </template>
                  <span class="text-subtitle-2 text-md-subtitle-1">
                    {{ request.service?.name }}
                  </span>
                </p>
              </v-col>

              <!-- Visitas -->
              <template v-if="currentVisit">
                <!-- Visit without confirmation || Visit in pending -->
                <v-col v-if="currentVisit.visit_status === 1" cols="12" md="12">
                  <p class="hidden-md-and-up mb-3">
                    <b v-if="currentVisit.visit_type.id === 4"
                      >Visita NO confirmada</b
                    >
                    <b v-else>Visita pendiente</b>
                  </p>
                  <v-chip
                    label
                    color="rapired"
                    text-color="white"
                    :class="{ dim: fab }"
                  >
                    <span
                      v-if="currentVisit.visit_type.id === 4"
                      class="hidden-sm-and-down"
                      >Visita NO confirmada:
                    </span>
                    <span v-else class="hidden-sm-and-down"
                      >Visita pendiente:
                    </span>
                    <span
                      v-if="currentVisit"
                      style="
                        font-weight: bold;
                        margin-left: 6px;
                        text-transform: capitalize;
                      "
                    >
                      {{
                        currentVisit.visit_date &&
                        formatDate(currentVisit.visit_date)
                      }}, {{ currentVisit.arrival_time }} -
                      {{ currentVisit.departure_time }} hs
                    </span>
                  </v-chip>
                </v-col>

                <!-- Visit in progress -->
                <v-col
                  v-else-if="currentVisit.visit_status === 8"
                  cols="12"
                  md="12"
                >
                  <v-chip
                    label
                    color="secondary"
                    text-color="white"
                    :class="{ dim: fab }"
                  >
                    <span>Visita en curso</span>
                  </v-chip>
                </v-col>

                <!-- Without visits -->
                <v-col
                  v-else-if="request.status_request?.id != 13"
                  cols="12"
                  md="12"
                >
                  <v-chip
                    label
                    color="secondary"
                    text-color="white"
                    :class="{ dim: fab }"
                  >
                    <span>El pedido no tiene visitas pendientes</span>
                  </v-chip>
                </v-col>
              </template>

              <!-- Client information -->
              <template v-if="request.client">
                <v-col cols="12" class="pb0">
                  <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                    Cliente
                  </h6>
                </v-col>

                <v-col cols="12" class="pt0">
                  <p class="m0 text-subtitle-2 text-md-subtitle-1">
                    {{ request.client.last_name }},
                    {{ request.client.first_name }}
                  </p>
                </v-col>

                <v-col
                  v-if="request.client.full_cell_phone"
                  cols="12"
                  class="pt0"
                >
                  <v-row justify="space-between" class="m0">
                    <p class="m0 text-subtitle-2 text-md-subtitle-1">
                      {{ request.client.full_cell_phone }}
                    </p>
                    <a
                      class="hidden-md-and-up"
                      :href="'tel:' + request.client.full_cell_phone"
                      ><v-icon color="rapired" :class="{ dim: fab }"
                        >smartphone</v-icon
                      ></a
                    >
                  </v-row>
                </v-col>
              </template>

              <!-- Request description -->
              <v-col cols="12" class="req__list">
                <h6
                  class="mb-2 ml-3 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Descripción del servicio
                </h6>
                <p class="req__list_item text-subtitle-2 text-md-subtitle-1">
                  {{ request.description }}
                </p>
              </v-col>

              <!-- Show visits -->
              <template v-if="showVisits">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" class="pa-0">
                      <h6
                        class="ml-3 mt-4 md-mt-8 text-subtitle-1 text-md-h6 font-weight-bold"
                      >
                        Visitas
                      </h6>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pb-0 visit"
                      v-for="visit in visits"
                      :key="visit.id"
                    >
                      <div
                        class="d-flex align-center pa-3"
                        style="border-radius: 5px"
                        :class="{
                          highlighted:
                            visit.visit_status === 1 ||
                            visit.visit_status === 8 ||
                            visit.visit_status === 12,
                          regular: visit.visit_status !== 1,
                        }"
                      >
                        <v-icon
                          color="warning"
                          v-if="visit.visit_status === 1"
                          :class="{ dim: fab }"
                          >event</v-icon
                        >
                        <v-icon
                          color="success"
                          v-if="
                            visit.visit_status === 2 ||
                            visit.visit_status === 14
                          "
                          :class="{ dim: fab }"
                          >check</v-icon
                        >
                        <v-icon
                          color="warning"
                          v-if="
                            visit.visit_status === 3 || visit.visit_status === 4
                          "
                          :class="{ dim: fab }"
                          >error</v-icon
                        >
                        <v-icon
                          color="success"
                          v-if="visit.visit_status === 8"
                          :class="{ dim: fab }"
                          >home</v-icon
                        >
                        <v-icon
                          color="success"
                          v-if="visit.visit_status === 12"
                          :class="{ dim: fab }"
                          >store</v-icon
                        >
                        <v-icon
                          color="error"
                          v-if="
                            visit.visit_status === 5 ||
                            visit.visit_status === 6 ||
                            visit.visit_status === 7 ||
                            visit.visit_status === 9 ||
                            visit.visit_status === 10 ||
                            visit.visit_status === 11 ||
                            visit.visit_status === 13
                          "
                          :class="{ dim: fab }"
                        >
                          clear
                        </v-icon>
                        <div class="ml-2">
                          <p
                            style="
                              margin-bottom: 0px;
                              font-size: 13px;
                              font-weight: bold;
                            "
                          >
                            <span
                              v-if="visit.visit_type.id === 4"
                              style="
                                font-size: 14px;
                                font-weight: bold;
                                border-radius: 12px;
                                background-color: #c8272a;
                                padding: 2px 6px;
                                color: white;
                              "
                            >
                              No Confirmada
                            </span>

                            <span v-else-if="visit.visit_status === 8">
                              Servicio en curso
                            </span>
                            <span v-else>
                              {{ visit.visit_status_name }}
                            </span>
                          </p>
                          <p
                            style="margin-bottom: 0; text-transform: capitalize"
                          >
                            {{
                              visit.visit_date && formatDate(visit.visit_date)
                            }}
                          </p>
                          <p style="margin-bottom: 0">
                            de {{ visit.arrival_time }} a
                            {{ visit.departure_time }} hs
                          </p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </template>

              <template v-else-if="request.status_request?.id != 13">
                <v-col cols="12" class="pb0">
                  <h6 class="text-subtitle-1 text-md-h6">Visitas</h6>
                </v-col>
                <v-col cols="12" class="pb0">
                  <p>El pedido aún no tiene servicios</p>
                </v-col>
              </template>
              <!-- Budget information -->

              <BudgetsPreview class="mt-4 mt-md-8" :requestId="request.id" />

              <v-col
                cols="12"
                class="pb0"
                v-if="
                  request.status_request?.id == 13 &&
                  currentVisit?.visit_type?.id !== 4
                "
              >
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Visitas
                </h6>
              </v-col>

              <v-col
                cols="12"
                class="pt0"
                v-if="request.status_request.id == 13"
              >
                <v-radio-group
                  style="margin: 0; font-size: 1rem"
                  :disabled="hasResponded"
                  v-model="selectedAvailability"
                >
                  <v-row v-for="(item, i) in request.availability" :key="i">
                    <!-- Date -->
                    <v-col
                      cols="10"
                      md="10"
                      style="padding-bottom: 0"
                      class="ml-2 d-flex flex-row justify-space-arround align-center"
                    >
                      <p
                        style="
                          margin: 0;
                          font-size: 0.9rem;
                          font-weight: 400;
                          color: #3a3a3a;
                        "
                      >
                        {{ getFormattedDate(item) }}
                      </p>

                      <!-- Radio button option -->
                      <v-radio
                        color="rapired"
                        :key="i"
                        :value="item.id"
                        class="ml-12"
                      ></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>

              <!-- Diagnostic questions Cristopher-->
              <v-col
                v-if="request.diagnostic_questions"
                cols="12"
                class="req__list"
              >
                <h6
                  class="mb-2 mt-4 mt-md-8 ml-3 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Preguntas de diagnóstico
                </h6>
                <p
                  class="req__list_item text-subtitle-2 text-md-subtitle-1"
                  v-for="(item, i) in request.diagnostic_questions"
                  :key="i"
                >
                  <v-icon
                    color="success"
                    v-if="item.checked"
                    :class="{ dim: fab }"
                    >assignment_turned_in</v-icon
                  >
                  <v-icon color="error" v-else :class="{ dim: fab }"
                    >remove_done</v-icon
                  >
                  {{ item.question }}
                </p>
              </v-col>
              <!-- Payment methods -->
              <v-col v-if="request?.payment_data" cols="12" class="req__list">
                <h6
                  class="mb-2 ml-3 mt-4 md-mt-8 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Métodos de pago
                </h6>
                <p
                  class="req__list_item text-subtitle-2 text-md-subtitle-1"
                  v-for="(item, i) in request.payment_methods"
                  :key="i"
                >
                  {{ item.name }}
                </p>
                <v-card
                  style="background-color: transparent"
                  class="d-flex flex-column"
                  elevation="0"
                >
                  <span
                    class="text-subtitle-2 text-md-subtitle-1 font-weight-bold ml-5"
                    >Nombre y Apellido:
                    <span class="font-weight-regular"
                      >{{ request.payment_data.nombre_prestador }}
                      {{ request.payment_data.apellido_prestador }}</span
                    ></span
                  >
                  <span
                    class="text-subtitle-2 text-md-subtitle-1 font-weight-bold ml-5"
                    >CUIT:
                    <span class="font-weight-regular">{{
                      request.payment_data.cuit
                    }}</span></span
                  >
                  <span
                    class="text-subtitle-2 text-md-subtitle-1 font-weight-bold ml-5"
                    >Banco:
                    <span class="font-weight-regular">{{
                      request.payment_data.banco
                    }}</span></span
                  >
                  <span
                    class="text-subtitle-2 text-md-subtitle-1 font-weight-bold ml-5"
                    >CBU:
                    <span class="font-weight-regular">{{
                      request.payment_data.cbu
                    }}</span></span
                  >
                </v-card>
              </v-col>
              <!-- Servicios facturados -->
              <v-col
                v-if="request.transactions?.length > 0"
                cols="12"
                class="pb0"
              >
                <h6
                  class="mt-4 md-mt-8 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Servicios facturados
                </h6>
                <BillServiceCard
                  v-for="transaction of request.transactions"
                  :key="transaction.id"
                  :transaction="transaction"
                />
              </v-col>

              <!-- Comprobantes de pago -->
              <v-col
                v-if="request.proof_of_payment_list?.length > 0"
                cols="12"
                class="pb0 mb-2"
              >
                <h6
                  class="mt-4 md-mt-8 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Comprobantes de pago
                </h6>

                <ProofItem
                  v-for="{
                    filename,
                    file,
                    proof_created_time,
                  } of request.proof_of_payment_list"
                  :key="filename"
                  :filename="filename"
                  :file="file"
                  :createdTime="proof_created_time"
                />
              </v-col>

              <!-- Facturas asociadas -->
              <v-col
                v-if="request.invoice_list?.length > 0"
                cols="12"
                class="pb0 mb-2"
              >
                <h6
                  class="mt-4 md-mt-8 text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Facturas asociadas
                </h6>
                <ProofItem
                  v-for="{
                    id,
                    filename,
                    file,
                    created_time,
                  } of request.invoice_list"
                  :key="id"
                  :filename="filename"
                  :file="file"
                  :createdTime="created_time"
                  icon="image"
                />
              </v-col>
            </v-row>
          </div>
        </v-row>

        <!-- Buttons -->
        <div class="bottom-bar">
          <v-row align="center">
            <v-col class="mobile-btn" cols="6">
              <v-btn
                class="hidden-md-and-up state-service-btn"
                v-if="
                  currentVisit?.visit_status === 1 &&
                  currentVisit?.visit_type.id !== 4 &&
                  request.status_request?.id !== 13
                "
                color="secondary"
                large
                @click="showCheckInConfirmDialog()"
                >Check-in</v-btn
              >
              <!-- En el boton FIN, agregue al v-if currentVisit.visit_status === 12 para que se vea, igual q finalizar servicio Cristopher -->
              <v-btn
                class="hidden-md-and-up state-service-btn"
                v-if="
                  request.status_request?.id !== 13 &&
                  (currentVisit?.visit_status === 8 ||
                    currentVisit?.visit_status === 12)
                "
                color="rapired"
                dark
                large
                @click="showCheckOutConfirmDialog()"
                >check-out</v-btn
              >
            </v-col>
            <!-- </v-row> no hacen falta Cristopher
          
          <v-row> -->
            <!-- btn mobile Cristopher -->
            <v-col class="interested-btn" cols="12">
              <v-btn
                class="hidden-md-and-up mb-3"
                style="width: 60%"
                v-if="showInterestedOptions"
                @click="iAmNotInterested"
                color="rapired"
                dark
                >No agendar</v-btn
              >

              <v-btn
                class="hidden-md-and-up"
                style="width: 60%"
                v-if="showInterestedOptions"
                @click="iAmInterested"
                :disabled="!selectedAvailability"
                color="secondary"
                >Agendar</v-btn
              >
            </v-col>
            <!-- btn mobile Cristopher -->

            <!-- btn desktop Cristopher -->
            <v-col cols="6" class="menu-container">
              <v-btn
                class="hidden-sm-and-down mr-6"
                v-if="showInterestedOptions"
                @click="iAmNotInterested"
                color="rapired"
                dark
                large
                >No agendar</v-btn
              >

              <v-btn
                class="hidden-sm-and-down"
                v-if="showInterestedOptions"
                @click="iAmInterested"
                :disabled="!selectedAvailability"
                color="secondary"
                large
                >Agendar</v-btn
              >
            </v-col>
            <!-- btn desktop Cristopher -->

            <v-col>
              <div class="state-services-menu">
                <v-btn
                  class="hidden-sm-and-down mr-12 mt-1"
                  v-if="
                    request?.status_request?.id !== 13 &&
                    currentVisit?.visit_status === 1 &&
                    currentVisit?.visit_type?.id !== 4
                  "
                  color="secondary"
                  large
                  @click="showCheckInConfirmDialog()"
                  >CHECK-IN</v-btn
                >

                <v-btn
                  class="hidden-sm-and-down mr-12 mt-1"
                  v-if="
                    request.status_request?.id != 13 &&
                    (currentVisit?.visit_status === 8 ||
                      currentVisit?.visit_status === 12)
                  "
                  color="rapired"
                  dark
                  large
                  @click="showCheckOutConfirmDialog()"
                  >check-out</v-btn
                >
                <v-speed-dial
                  style="justify-self: flex-end"
                  v-model="fab"
                  direction="top"
                  transition="slide-y-reverse-transition"
                  v-if="
                    request?.status_request?.id != 13 ||
                    (currentVisit?.visit_type?.id !== 4 &&
                      currentVisit?.visit_status !== 13 &&
                      currentVisit?.visit_status !== 14)
                  "
                >
                  <template v-slot:activator>
                    <v-btn v-model="fab" color="rapired" dark fab>
                      <v-icon v-if="fab">mdi-close</v-icon>
                      <v-icon v-else>menu</v-icon>
                    </v-btn>
                  </template>

                  <v-btn
                    v-if="
                      requestHasPendingVisit ||
                      currentVisit?.visit_status === 12
                    "
                    style="transform: translateX(-68px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="cancelVisitDialog = true"
                  >
                    Cancelar visita
                    <v-icon right dark>clear</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="
                      requestIsActive &&
                      requestHasPendingVisit &&
                      currentVisit?.visit_status !== 1
                    "
                    style="transform: translateX(-58px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="rescheduleVisitDialog = true"
                  >
                    Reprogramar
                    <v-icon right dark>access_time</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="requestHasPendingVisit"
                    style="transform: translateX(-55px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="noAnswerDialog = true"
                  >
                    No hay nadie
                    <v-icon right dark>error_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="requestHasPendingVisit"
                    style="transform: translateX(-84px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="delayedArrivalDialog = true"
                  >
                    Horario de llegada
                    <v-icon right dark>timer</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="!isNewOpportunity"
                    style="transform: translateX(-60px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="
                      $router.push({
                        name: 'budget-list',
                        query: { requestId: request.id },
                      })
                    "
                  >
                    Presupuestos
                    <v-icon right dark>attach_money</v-icon>
                  </v-btn>

                  <v-btn
                    style="transform: translateX(-33px)"
                    color="#eeeeee"
                    class="ma-2"
                    rounded
                    large
                    @click="galleryDialog = true"
                  >
                    Galería
                    <v-icon right dark>collections</v-icon>
                  </v-btn>
                </v-speed-dial>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>

    <ConfirmCheckInDialog
      v-if="checkInDialog"
      :show="checkInDialog"
      @close-dialog="checkInDialog = false"
      @confirm-checkin="checkIn"
    />
    <ConfirmCheckOutDialog
      v-if="checkOutDialog"
      :show="checkOutDialog"
      @close-dialog="checkOutDialog = false"
      @endmetting-dialog="endMeetingDialog = true"
    />
    <AppGallery
      v-if="galleryDialog"
      :show="galleryDialog"
      :noAnswer="noAnswer"
      :gallery="request.gallery"
      :requestId="request.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="galleryDialog = false"
    />
    <DelayedArrivalDialog
      v-if="delayedArrivalDialog"
      :show="delayedArrivalDialog"
      :requestId="request.id"
      :requestAddress="request.full_address"
      :visitId="currentVisit.id"
      @close-dialog="delayedArrivalDialog = false"
    />
    <ScheduleNewVisitDialog
      v-if="scheduleNewVisitDialog"
      :show="scheduleNewVisitDialog"
      :requestId="request.id"
      :technicianId="computedDetail.id"
      :requestAddress="request.full_address"
      :onPremises="currentVisit?.on_premises ?? null"
      :serviceId="request.service.id"
      @visit-scheduled="scheduleVisit"
      @close-dialog="scheduleNewVisitDialog = false"
    />
    <RescheduleVisitDialog
      v-if="rescheduleVisitDialog"
      :show="rescheduleVisitDialog"
      :requestId="request.id"
      :requestAddress="request.full_address"
      :visitId="currentVisit.id"
      :onPremises="currentVisit.on_premises"
      :serviceId="request.service.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="rescheduleVisitDialog = false"
    />
    <NoAnswerDialog
      v-if="noAnswerDialog"
      :show="noAnswerDialog"
      @close-dialog="noAnswerDialog = false"
      @confirm-noanswer="confirmNoAnswer"
    />
    <end-meeting-dialog
      v-if="endMeetingDialog"
      :show="endMeetingDialog"
      :visit="currentVisit"
      :request="request"
      @close-dialog="endMeetingDialog = false"
      @reload-request="refetchRequestDetail"
    />

    <FinalizeServiceDialog
      v-if="finalizeServiceDialog"
      :show="finalizeServiceDialog"
      :requestId="request.id"
      :visitId="currentVisit.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="finalizeServiceDialog = false"
    />

    <CancelVisitDialog
      v-if="cancelVisitDialog"
      :show="cancelVisitDialog"
      :visitId="currentVisit.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="cancelVisitDialog = false"
    />
  </section>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";

import BudgetsPreview from "./BudgetsPreview";
import AppGallery from "./AppGallery";
import ConfirmCheckInDialog from "./ConfirmCheckInDialog";
import ConfirmCheckOutDialog from "./ConfirmCheckOutDialog";
import DelayedArrivalDialog from "./DelayedArrivalDialog";
import ScheduleNewVisitDialog from "./ScheduleNewVisitDialog";
import RescheduleVisitDialog from "./RescheduleVisitDialog";
import FinalizeServiceDialog from "./FinalizeServiceDialog";
import NoAnswerDialog from "./NoAnswerDialog";
import CancelVisitDialog from "./CancelVisitDialog";
import Loader from "./Loader";
// import ChatDetail from "./ChatDetail";
import EndMeetingDialog from "./Mobs/EndMeetingDialog.vue";
import BillServiceCard from "./BillServiceCard.vue";
import ProofItem from "./ProofItem";
import SchemeIcon from "./SchemeIcon";

export default {
  name: "RequestDetail",
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  components: {
    AppGallery,
    BudgetsPreview,
    ConfirmCheckInDialog,
    ConfirmCheckOutDialog,
    DelayedArrivalDialog,
    ScheduleNewVisitDialog,
    RescheduleVisitDialog,
    FinalizeServiceDialog,
    CancelVisitDialog,
    NoAnswerDialog,
    // ChatDetail,
    Loader,
    EndMeetingDialog,
    BillServiceCard,
    ProofItem,
    SchemeIcon,
  },

  data: () => ({
    selectedAvailability: null,
    galleryDialog: false,
    delayedArrivalDialog: false,
    scheduleNewVisitDialog: false,
    rescheduleVisitDialog: false,
    endMeetingDialog: false,
    finalizeServiceDialog: false,
    cancelVisitDialog: false,
    fab: false,
    checkInDialog: false,
    checkOutDialog: false,
    noAnswerDialog: false,
    noAnswer: false,
  }),

  mounted() {
    this.$store.commit("set_app_title", `Pedido ${this.displayId}`);
  },

  computed: {
    ...mapState("request", ["currentDetail"]),
    ...mapGetters("request", ["detailLoading"]),

    computedDetail() {
      return this.currentDetail ?? this.detail;
    },

    request() {
      return this.computedDetail.request;
    },

    displayId() {
      if (this.request.external_id) {
        return `${this.request.id} (${this.request.external_id})`;
      }
      return this.request.id;
    },

    visits() {
      return this.computedDetail.visit;
    },

    currentVisit() {
      const foundStatus1 = this.visits?.find(
        (visit) => visit.visit_status === 1
      );

      if (foundStatus1) {
        return foundStatus1;
      }

      const foundStatus8 = this.visits?.find(
        (visit) => visit.visit_status === 8
      );

      if (foundStatus8) {
        return foundStatus8;
      }

      if (this.visits?.length > 0) {
        return this.visits[0];
      }

      return undefined;
    },

    originAddress() {
      return this.request.same_address
        ? this.request.address_request.full_address
        : this.request.address_client.full_address;
    },

    requirementFilter() {
      const requirements = this.request.diagnostic_questions.filter(
        (item) => item.checked
      );
      return requirements;
    },

    checkTimeSlot() {
      return this.selectedAvailability;
    },

    checkStatus() {
      return `${this.request.status_request.description}`;
    },

    showInterestedOptions: function () {
      return (
        this.request?.status_request?.id === 13 && this.request?.respuesta == 1
      );
    },

    hasResponded: function () {
      return this.request.respuesta && this.request.respuesta != 1;
    },

    showVisits: function () {
      if (this.request?.status_request?.id === 13) {
        switch (this.request.respuesta) {
          case 1:
            return false;
          case 2:
            return true;
          case 3:
            return false;
        }
      }
      return !!this.visits?.length;
    },

    googleMapsLink: function () {
      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.request.address_request.maps_address +
        "%20"
      );
    },
    googleMapsLinkClient: function () {
      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.request.address_client.maps_address +
        "%20"
      );
    },

    requestHasPendingVisit: function () {
      if (this.requestVisits == null) return false;
      const pendingVisit = this.requestVisits.find(
        (visit) => visit.visit_status === 1
      );
      if (pendingVisit) {
        return true;
      } else {
        return false;
      }
    },

    requestIsActive: function () {
      return (
        this.request?.status_request?.id === 10 ||
        this.request?.status_request?.id === 11 ||
        this.request?.status_request?.id === 12 ||
        this.request?.status_request?.id === 13
      );
    },

    isNewOpportunity: function () {
      return this.request?.status_request?.id === 13;
    },

    showChargesOption: function () {
      return this.requestVisits?.some(
        ({ visit_status }) => visit_status === 2 || visit_status === 8
      );
    },

    hasPermissionGranted() {
      if (!("Notification" in window)) return false;
      return Notification.permission === "granted";
    },
  },

  methods: {
    ...mapActions("request", ["getRequestById"]),

    async refetchRequestDetail() {
      try {
        await this.getRequestById(this.request.id);
      } catch (error) {
        console.error(error);
      }
    },

    getPreviouslySelectedAvailability: function () {
      const result = this.request.availability.find(
        (item) =>
          item.time_from.slice(0, 10) == this.visits[0].visit_date &&
          item.time_from.slice(11, 16) == this.visits[0].arrival_time
      );
      this.selectedAvailability = result.id;
    },

    getFormattedDate(av) {
      if (av.time_from) {
        const from = moment(av.time_from);
        const to = moment(av.time_to);
        let formatted = "Desde" + " " + from.format("dddd DD MMMM");
        formatted +=
          " " +
          from.format("HH:mm") +
          " hs" +
          ", " +
          " Hasta " +
          from.format("dddd DD MMMM") +
          " " +
          to.format("HH:mm") +
          " hs";
        return formatted;
      }
    },

    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },

    showCheckInConfirmDialog() {
      this.checkInDialog = true;
    },

    showCheckOutConfirmDialog() {
      this.endMeetingDialog = true;
    },

    checkIn() {
      const id = this.mobsUser ? 15 : 10;
      const body = { id: id, on_premises: true };
      this.axios
        .post(`/visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.refetchRequestDetail();
        });
    },

    checkOut() {
      const body = { id: 13 };
      this.axios
        .post(`/visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.refetchRequestDetail();
        });
    },

    confirmNoAnswer() {
      const body = { id: 2 };

      this.axios
        .post(`visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.noAnswer = true;
          this.galleryDialog = true;
        })
        .catch((error) => {
          alert("Ha ocurrido un error");
        });
    },

    setAppTitle(title) {
      this.$store.commit("set_app_title", `#${title}`);
    },

    scheduleVisit() {
      this.refetchRequestDetail();
    },

    finalizeService() {
      this.finalizeServiceDialog = true;
    },

    iAmInterested() {
      const body = {
        reply: true,
        availability: this.selectedAvailability,
      };

      const { id } = this.computedDetail;

      if (id) {
        this.axios
          .put(`request_technician/${id}/reply/`, body)
          .then((_) => {
            this.$route.params &&
              this.$route.params.notificationId &&
              this.axios.delete(
                `notification/${this.$route.params.notificationId}/`
              );
            this.$store.commit("show_alert", "Se ha marcado como Interesado");
            this.refetchRequestDetail();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    iAmNotInterested() {
      const body = {
        reply: false,
      };
      const { id } = this.computedDetail;

      if (id) {
        this.axios
          .put(`request_technician/${id}/reply/`, body)
          .then((_) => {
            this.$route.params &&
              this.$route.params.notificationId &&
              this.axios.delete(
                `notification/${this.$route.params.notificationId}/`
              );
            this.$store.commit(
              "show_alert",
              "Se ha marcado como No Interesado"
            );
            this.refetchRequestDetail();
            this.$router.push("notification-list");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },

  watch: {
    computedDetail: {
      handler(newValue) {
        if (
          newValue &&
          newValue.respuesta === 2 &&
          this.isNewOpportunity &&
          this.hasResponded
        ) {
          this.getPreviouslySelectedAvailability();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* se quito de finzaliar servicio mobile porque se agrego cancelar servicio Cristopher
.end-btn {
  position: relative;
  left: 6rem;
} */
.icon-details {
  width: 25px;
}
.interested-btn {
  position: relative;
  bottom: 3.5rem;
}
@media (max-width: 600px) {
  .interested-btn > .v-btn {
    width: 90% !important;
  }
}
@media (max-width: 420px) {
  .state-services-menu {
    right: 6rem;
  }
  .state-service-btn {
    left: 2rem;
  }
}

img {
  width: 2%;
}
.state-services-menu {
  position: fixed;
  bottom: 1.5rem;
  display: flex;
}
.bottom-bar {
  position: fixed;
  display: flex;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
}
.v-speed-dial {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 959px) {
  img {
    width: 5%;
  }
  .mobile-btn {
    display: flex;
    justify-content: flex-end;
    padding-top: 1.5rem;
  }
  .bottom-bar {
    padding: 0 24px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
  }
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
  .dim {
    opacity: 0.3;
  }
  .visit {
    border-bottom: 1px solid lightgrey;
    padding: 0px;
  }
  .left-col {
    width: 100%;
  }
}
@media (min-width: 960px) {
  .dim {
    opacity: 0.3;
  }
  /* si se comenta el .bottom-bar se mueve todo mas a la derecha Cristopher */
  /* .bottom-bar {
    position: fixed;
    padding: 0 24px;
    bottom: 0;
    left: 0;
    width: 73%;
    height: 100px;
  } */
  .left-col {
    width: 65%;
  }
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
  .regular {
    background: #eeeeee;
  }
  .visit {
    padding: 12px;
  }
  .fix-desk {
    transform: translateX(260px);
  }
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
}
.left-col {
  transition: 1s;
}
.highlighted {
  background: #e1f5fe;
}

.menu-container {
  padding: 0;
  display: flex;
  justify-content: flex-end;
}
.bodypad {
  padding: 12px 24px 108px 24px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.in-bl {
  display: inline-block;
}
.icon-cont {
  display: flex;
  justify-content: flex-end;
}
.fab-but-cont {
  display: flex;
  justify-content: flex-start;
}
.loader-container {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.urgent {
  background-color: rgba(255, 251, 203, 0.5) !important;
}

.req__list {
  display: flex;
  padding: 0;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 0.5rem;
  font-size: 1rem;
  color: #3a3a3a;
}
.req__list_item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  font-weight: bold;
  margin-left: 1.2rem;
  font-weight: 400;
}

.v-application p {
  margin-bottom: 0px;
}
</style>
